__turbopack_context__.v({
  "VPadDevCard": "VPadDevCard-module__ZXkFcG__VPadDevCard",
  "connected": "VPadDevCard-module__ZXkFcG__connected",
  "contentWrapper": "VPadDevCard-module__ZXkFcG__contentWrapper",
  "ellipse": "VPadDevCard-module__ZXkFcG__ellipse",
  "icon": "VPadDevCard-module__ZXkFcG__icon",
  "infoWrapper": "VPadDevCard-module__ZXkFcG__infoWrapper",
  "optionsWrapper": "VPadDevCard-module__ZXkFcG__optionsWrapper",
  "statusLabel": "VPadDevCard-module__ZXkFcG__statusLabel",
  "statusWrapper": "VPadDevCard-module__ZXkFcG__statusWrapper",
  "suspended": "VPadDevCard-module__ZXkFcG__suspended",
});
